const base = {
    get() {
        // 本地开发：VUE_APP_WS_URL 直接写死地址
        // 生产环境：VUE_APP_WS_URL 为空，自动根据当前域名和协议拼接
        const wsUrl = process.env.VUE_APP_WS_URL;
        if (wsUrl) {
            return {
                url : process.env.VUE_APP_BASE_URL + '/loraImg/',
                file: process.env.VUE_APP_BASE_URL + '/utils/upload',
                ws  : wsUrl
            };
        }
        const wsProtocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
        const wsHost = location.host;
        return {
            url : "/api/loraImg/",
            file: '/api/utils/upload',
            ws  : `${wsProtocol}//${wsHost}/ws/1`
        };
    }
}
export default base
